<template>
  <dropdown :class="`form-group ${error && error.invalidFeedback?'has-error':''}`" v-if="type === 'date'">
    <label>{{label}}</label>
    <div class="input-group">
      <input class="form-control" type="text" :value="value" @input="onChange">
      <div class="input-group-btn">
        <btn class="dropdown-toggle"><i class="glyphicon glyphicon-calendar"></i></btn>
      </div>
    </div>
    <template slot="dropdown">
      <li>
        <date-picker class="date-picker" :value="value" format="yyyy-MM-dd" @input="onChange"
                     :limit-to="disabledDates&&disabledDates.to?disabledDates.to:null"
                     :limit-from="disabledDates&&disabledDates.from?disabledDates.from:null"/>
      </li>
    </template>
    <span v-if="error? error.invalidFeedback:''" class="help-block">
      {{error.invalidFeedback}}
    </span>
    <span v-else-if="description" class="help-block">
      {{description}}
    </span>
  </dropdown>
  <form-group v-else :label="label" :invalid-feedback="error ?   error.invalidFeedback:''" :description="description">
    <template v-if="type === 'select'">
      <div v-if="tooltip">
        <div style="display:inline-block;width: 91%">
          <multiselect :value="value" :options="options" :track-by="trackBy" :label="optionLabel" :multiple="multiple"
                       @search-change="onSearchChange"
                       :close-on-select="closeOnSelect" @input="onChange"/>
        </div>
        <div style="display:inline-block;width: 6%">
          <tooltip :text="tooltip" :target="'#' + id"/>
          <span class="help-icon" style="position:relative;top:5px" :id="id"/>
        </div>
      </div>
      <multiselect v-else :value="value" :options="options" :track-by="trackBy" :label="optionLabel"
                   :multiple="multiple"
                   @search-change="onSearchChange"
                   :close-on-select="closeOnSelect" @input="onChange"/>
    </template>
    <template v-else-if="type === 'checkbox'">
      <div class="checkbox" @click="onChange">
        <input type="checkbox" :value="value"/>
        <label><span class="help-icon" :id="id"/></label>
        <tooltip v-if="tooltip" :text="tooltip" :target="'#' + id"/>
      </div>
    </template>
    <template v-else>
      <input class="form-control" :value="value" :type="type" @input="onChange"
             :placeholder="inputPlaceholder?inputPlaceholder:null"/>
    </template>
  </form-group>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import FormGroup from '@/components/shared/form-group'

  export default {
    components: {
      Multiselect,
      FormGroup
    },
    props: [
      'value', 'label', 'error', 'type', 'options', 'trackBy', 'multiple', 'close-on-select', 'optionLabel',
      'inputPlaceholder', 'description', 'format', 'search-change', 'internalSearch', 'searchable', 'disabledDates',
      'tooltip', 'id'
    ],
    name: 'fieldWrapper',
    data () {
      return {}
    },
    methods: {
      onChange (eventOrValue) {
        if (this.type === 'checkbox') {
          this.$emit('input', !this.value)
        } else {
          this.$emit('input', (eventOrValue && eventOrValue.target) ? eventOrValue.target.value : eventOrValue)
        }
      },
      onSearchChange (value) {
        this.$emit('search-change', value)
      }
    }
  }
</script>
